import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ChevronRight, Award } from 'lucide-react';
import styled from 'styled-components';

import api from '../../../services/api';
import { formatDate } from '../../../utils/Utils';
import DocumentViewerModal from '../../../components/ui/DocumentViewerModal';
import {
  Card,
  CardHeader,
  CardTitle,
  EmptyState,
  ScrollList,
  ListItem,
  ListItemContent,
  ListItemName,
  ListItemSub,
} from '../styles';

const HeaderLink = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.primary.main};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

const IconCircle = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10B981, #34D399);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
`;

export default function MyCertificatesCard() {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  // { fileUrl, title } | null — açık olduğunda DocumentViewerModal'ı besler. Sertifika PDF'i
  // özel sınıfa taşındı (StorageVisibility.Private) — kayıtlı adres artık `window.open` ile
  // doğrudan açılamaz; DocumentViewerModal kendisi `/v1/storage/view` üzerinden çözer (beş
  // özlük-dosyası yüzeyiyle aynı desen).
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    api.get('/v1/training-certificates/my', { params: { pageNumber: 1, pageSize: 5 } })
      .then((res) => {
        const result = res.data?.data;
        setItems(result?.data || []);
        setTotal(result?.totalRowCount || 0);
      })
      .catch(() => {});
  }, []);

  if (total === 0 && items.length === 0) return null;

  return (
    <Card $delay="0.15s">
      <CardHeader>
        <CardTitle>
          {t('dashboard.myLatestCertificates')}
          {total > 0 ? ` (${total})` : ''}
        </CardTitle>
        <HeaderLink onClick={() => history.push('/my-certificates')}>
          {t('common.seeAll')}
          <ChevronRight size={14} />
        </HeaderLink>
      </CardHeader>
      {items.length === 0 ? (
        <EmptyState>
          <Award size={28} />
          {t('dashboard.noCertificatesYet')}
        </EmptyState>
      ) : (
        <ScrollList>
          {items.map((item) => (
            <ListItem
              key={item.id}
              data-testid="certificate-item"
              style={{ cursor: 'pointer' }}
              onClick={() => item.pdfUrl && setViewing({ fileUrl: item.pdfUrl, title: item.trainingTitle })}
            >
              <IconCircle><Award size={18} /></IconCircle>
              <ListItemContent>
                <ListItemName>{item.trainingTitle}</ListItemName>
                <ListItemSub>
                  {item.certificateNumber} · {formatDate(item.issuedAt, i18n.language)}
                </ListItemSub>
              </ListItemContent>
            </ListItem>
          ))}
        </ScrollList>
      )}
      <DocumentViewerModal
        open={!!viewing}
        fileUrl={viewing?.fileUrl}
        title={viewing?.title}
        onClose={() => setViewing(null)}
      />
    </Card>
  );
}
